module.exports = "/_next/static/images/3-1-c5f745c3651d44f7052b27606adf251b.svg";